var _g, _path, _path2, _path3, _g2, _g3, _g4, _path4, _path5, _path6, _path7, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadingArchives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_24786_52384)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 36,
    height: 36,
    rx: 8,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4246 7.28248C12.2062 5.50089 14.6226 4.5 17.1421 4.5H29C30.933 4.5 32.5 6.067 32.5 8V36.6667C32.5 38.5997 30.933 40.1667 29 40.1667H7C5.067 40.1667 3.5 38.5997 3.5 36.6667V18.1421C3.5 15.6226 4.50089 13.2062 6.28249 11.4246L10.4246 7.28248Z",
    fill: "#FF6300",
    stroke: "#FF6300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83203 20.166H26.332",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 26H16",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_24786_52384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.643 6.35702L5.92893 11.0711C4.05357 12.9464 3 15.5145 3 18.1667C3.02344 15.8587 4.90108 14 7.2092 14H10.1365C11.718 14 13 12.718 13 11.1365V7.35292C13 5.50879 14.4892 4.01081 16.3333 4C14.199 4 12.1522 4.84784 10.643 6.35702Z",
    fill: "#FFA300"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_24786_52384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.41797 23.9993L3.41797 18.5827L3.43013 17.3855C3.44683 15.7407 4.78501 14.416 6.42997 14.416H8.41797C11.1794 14.416 13.418 12.1774 13.418 9.41602V7.41802C13.418 5.76803 14.7504 4.42774 16.4004 4.41807L16.7513 4.41602H21.3346",
    stroke: "#FF6300"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_24786_52384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 28C20 23.5817 23.5817 20 28 20H48C52.4183 20 56 23.5817 56 28V48C56 52.4183 52.4183 56 48 56H28C23.5817 56 20 52.4183 20 48V28Z",
    fill: "url(#paint0_linear_24786_52384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 28C20 23.5817 23.5817 20 28 20H48C52.4183 20 56 23.5817 56 28V48C56 52.4183 52.4183 56 48 56H28C23.5817 56 20 52.4183 20 48V28Z",
    fill: "url(#paint1_radial_24786_52384)",
    fillOpacity: 0.5
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44V46C30 47.1046 30.8954 48 32 48H46C47.1046 48 48 47.1046 48 46V44",
    stroke: "#88A2B1",
    strokeOpacity: 0.2,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39 29.5V41.5M39 41.5L34 36.5M39 41.5L44 36.5",
    stroke: "#88A2B1",
    strokeOpacity: 0.2,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 43V45C29 46.1046 29.8954 47 31 47H45C46.1046 47 47 46.1046 47 45V43",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38 28.5V40.5M38 40.5L33 35.5M38 40.5L43 35.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_24786_52384)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 20.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "url(#paint2_radial_24786_52384)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 20.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "url(#paint3_radial_24786_52384)",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 20.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "url(#paint4_radial_24786_52384)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_24786_52384",
    x: 16,
    y: 16,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24786_52384"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24786_52384",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_24786_52384",
    x: -5,
    y: -4,
    width: 29.333,
    height: 30.1665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24786_52384"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24786_52384",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_24786_52384",
    x: -5.08203,
    y: -4.08398,
    width: 34.417,
    height: 36.0835,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24786_52384"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24786_52384",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_24786_52384",
    x: 12,
    y: 12,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24786_52384"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24786_52384",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_24786_52384",
    x: 16,
    y: 16,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24786_52384"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24786_52384",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24786_52384",
    x1: 20,
    y1: 20,
    x2: 38,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_24786_52384",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 20) scale(36)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_24786_52384",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5 43.5) rotate(6.1155) scale(14.0801)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_24786_52384",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5 26.5) rotate(135) scale(6.36396 28.1317)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_24786_52384",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5 27) rotate(116.565) scale(16.7705)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadingArchives);
export default __webpack_public_path__ + "static/media/uploadingArchives.44630b959a81753b36c6d16662a93973.svg";
export { ForwardRef as ReactComponent };